import { RouteType } from "routes/types";

const COMMON_ROUTES: RouteType[] = [];

export default COMMON_ROUTES;
